import { render, staticRenderFns } from "./SubScreen.vue?vue&type=template&id=73eb84ab&scoped=true&"
import script from "./SubScreen.vue?vue&type=script&lang=ts&"
export * from "./SubScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SubScreen.vue?vue&type=style&index=0&id=73eb84ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb84ab",
  null
  
)

export default component.exports